import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { getBidderByUuid, updateBidderForEvent } from "services";

interface JBOfflineViewerFinalSubmissionProps {
  bidderUuid: any;
  activeStep: number;
  setActiveStep: any;
  init: any;
}

export default function JBOfflineViewerFinalSubmission({
  bidderUuid,
  activeStep,
  setActiveStep,
  init,
}: JBOfflineViewerFinalSubmissionProps) {
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const hasAutoSubmittedRef = useRef(false);

  const handleFinalSubmission = async () => {
    setIsSubmitting(true);
    setError(null);
    try {
      const data: any = await getBidderByUuid(bidderUuid);

      if (data?.meta?.steps_status?.completed === "completed") {
        setActiveStep((prev: number) => prev + 1);
        await init();
        return;
      }

      if (
        data?.access_type === "viewer" &&
        data?.meta?.primary_bidder_uuid &&
        data?.is_joint === true
      ) {
        const primaryBidderUuid = data?.meta?.primary_bidder_uuid;
        const primaryBidderData: any = await getBidderByUuid(primaryBidderUuid);
        const biddersConsent = primaryBidderData?.esigned_data?.consent_data || [];
        const consentData = biddersConsent.map((consent: any) =>
          consent.bidder_uuid === bidderUuid
            ? {
                ...consent,
                consent_status: "approved",
              }
            : consent,
        );

        await updateBidderForEvent({
          uuid: primaryBidderUuid,
          esigned_data: {
            ...primaryBidderData?.esigned_data,
            consent_data: consentData,
          },
        });
      }

      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          submission_time: new Date().toISOString(),
          steps_status: {
            ...data?.meta?.steps_status,
            approver_details: "completed",
            completed: "completed",
          },
        },
        kyc_data: {
          ...data?.kyc_data,
          kyc_approver_details: {
            ...data?.kyc_data?.kyc_approver_details,
            form_submission: "submitted",
          },
        },
        verification_step: "completed",
        digio_request_status: "approved",
      });

      setActiveStep((prev: number) => prev + 1);
      await init();
    } catch (error) {
      console.log("error: ", error);
      setError("We could not complete your submission automatically.");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!bidderUuid || hasAutoSubmittedRef.current) return;
    hasAutoSubmittedRef.current = true;
    handleFinalSubmission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bidderUuid]);

  return (
    <div className="py-4">
      <div className="border border-brand-borderLightGray rounded-lg p-4 bg-white">
        <div className="flex items-start gap-3">
          <div className="mt-1 h-5 w-5 rounded-full border-2 border-brand-orange border-t-transparent animate-spin" />
          <div>
            <div className="text-sm font-semibold text-brand-textBlack">
              Final Submission
            </div>
            <div className="mt-1 text-sm text-brand-textGrey">
              {isSubmitting
                ? "Submitting your participation request. Please wait..."
                : error
                  ? error
                  : "Submission completed. Redirecting to status..."}
            </div>
          </div>
        </div>
      </div>
      {error && (
        <div className="mt-4 flex">
          <Button
            className="w-full max-w-xl h-10 text-sm"
            onClick={handleFinalSubmission}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Retrying..." : "Retry Submission"}
          </Button>
        </div>
      )}
    </div>
  );
}

